import { Component, OnInit, Input, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Config } from '../classes/Config';
import { InternationalizationHelper } from '../helpers/InternationalizationHelper';

declare var AppleID: any;

@Component({
  selector: 'app-sign-in-apple',
  templateUrl: './sign-in-apple.component.html',
  styleUrls: ['./sign-in-apple.component.scss']
})
export class SignInAppleComponent implements OnInit, AfterViewInit {

  @Input() changeToApple: boolean = false;
  @ViewChild("appleSignIn", {static: false}) appleSignIn: ElementRef;
  lang: string = "en";

  constructor(
  ) { }

  ngOnInit() {

    if (typeof AppleID !== 'undefined' && AppleID) {
      this.initApple();
    }
    else {
      setTimeout(() => {
        if (typeof AppleID !== 'undefined' && AppleID) {
          this.initApple();
        }
      }, 1000);
    }

    let l = InternationalizationHelper.getTwoCharactersLanguage();
    if(l != "de") { l = "en"; }
    this.lang = l;

  }

  ngAfterViewInit() {
    setTimeout(() => {
      const signInDiv = document.querySelector("#appleid-signin > div");
      if(signInDiv) {
        signInDiv["style"].width = "100%";
        signInDiv["style"].height = "100%";
      }
      const signInDiv2 = document.querySelectorAll("#appleid-signin > div > div")[1];
      if(signInDiv2) {
        signInDiv2["style"].display = "grid";
        signInDiv2["style"].height = "40px";
      }
    });
  }

  initApple() {
    if (typeof AppleID !== 'undefined' && AppleID && AppleID.auth) {
      try {
        AppleID.auth.init({
          clientId: 'com.lollipapp.cheapcharts.client',
          scope: 'name email',
          redirectURI: Config.frontendUrl + '/siwa/siwa_redirect.php',
          state: btoa(JSON.stringify({
            url: location.href,
            changeToApple: this.changeToApple
          }))
        });
      } catch (error) {
        // Silently handle initialization errors - AppleID script may not be available
        console.warn('AppleID initialization failed:', error);
      }
    }
  }

  signIn() {
    this.appleSignIn.nativeElement.click();
  }

}
